<template>
  <Stepper v-model:step="atStep" @direction="onDirection" @change="stepChanged" :steps="steps">
    <template #default="{ step, prev, next, hasPrev, hasNext, isNextAvailable, isLastStep }">
      <div>
        <div
          class="flex w-full border-b border-solid border-gray-light pb-4  mb-4 sm:mb-8 justify-between content-center"
        >
          <StepwizzardErrorReport :activeStep="atStep" :stepName="step" :steps="steps" />
          <div class="flex flex-col pt-1">
            <Button
              variant="tertiary"
              size="large"
              @click="resetErrorReportForm"
            >
              Börja om
              <template #icon-after>
                <IconReload />
              </template>
            </Button>
          </div>
        </div>

       <!-- <div>
          parentId: {{parentId}} <br />
          laundryCode: {{laundryCode}}<br />
          locationId (i lgh): {{locationId }}<br />
          partCode: {{partCode}}<br />
          subPartCode: {{subPartCode}}
        </div>-->
        <div class="flex flex-col">
          <main class="flex-1 pb-6 sm:pb-4">
            <p v-if="step == 'subPartCode' && isDuplicate === true" class="text-b1">
            Du har redan ett pågående ärende av samma typ och kan därför inte registrera ett nytt ärende
            med samma fel. Har du frågor vänligen kontakta kundcentrum.
          </p>

          <div v-else>
            <LoaderErrorReport v-if="!steps.length" />
            <div v-if="step === 'areaCode'" class="flex flex-col gap-4">
              <div
                class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                v-html="instructions.errorreport_create_edit_row_areacode_html"
              ></div>

              <Transition name="loader-fade" mode="out-in">
                <template v-if="isFetching == false && !!baseCategories">
                  <ChooseArea v-model:areaCode="areaCode" @change="onChange('areaCode', areaCode, true)" :dir="direction" />
                </template>
                <LoaderErrorReport v-else />
              </Transition>
            </div>


            <div v-if="step === 'rentalObjectCode'" class="flex flex-col gap-4">
              <div
                class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                v-html="instructions.errorreport_create_edit_row_rentalobjectcode_html"
              ></div>

              <Transition name="loader-fade" mode="out-in">
                <template v-if="!isFetching">
                  <ChooseContractForLaundry
                    :areaCode="areaCode"
                    :dir="direction"
                    v-model:rentalObjectCode="rentalObjectCode"
                    v-model:floorPlanUrl="floorPlanUrl"
                    @change="onChange('rentalObjectCode', rentalObjectCode, true)"
                  />
                </template>
                <LoaderErrorReport v-else />
              </Transition>
            </div>

            <div v-if="step === 'laundryroom'" class="flex flex-col gap-4">
              <div v-if="areaCode == 'laundryroom'"
                class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                v-html="instructions.errorreport_create_edit_row_laundryroom_html"
              ></div>
              <div v-else-if="areaCode == 'playground'"
                   class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                   v-html="instructions.errorreport_create_edit_row_playground_html"
              ></div>
              <Transition name="loader-fade" mode="out-in">
                <template v-if="!isFetching">
                  <ChooseLaundryRoom
                    :dir="direction"
                    v-model:rentalObjectCode="rentalObjectCode"
                    v-model:laundryCode="laundryCode"
                    @update:laundryCode="onChange('laundryCode', laundryCode, true)"
                  />
                </template>
                <LoaderErrorReport v-else />
              </Transition>

            </div>

            <!-- playground-->
           <div v-if="step === 'playground'" class="flex flex-col gap-4">
              <div
                class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                v-html="instructions.errorreport_create_edit_row_playground_html"
              ></div>
              <Transition name="loader-fade" mode="out-in">
                <template v-if="!isFetching">
                  <ChooseLaundryRoom
                    :dir="direction"
                    v-model:rentalObjectCode="rentalObjectCode"
                    v-model:laundryCode="laundryCode"
                    @update:laundryCode="onChange('laundryCode', laundryCode, true)"
                  />
                </template>
                <LoaderErrorReport v-else />
              </Transition>
            </div>


            <div v-if="step === 'locationCode'" class="flex flex-col gap-4">
              <div
                class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                v-html="instructions.errorreport_create_edit_row_locationcode_html"
              ></div>


              <Modal v-if="showBlueprint" @cancel="showBlueprint = false" :hasCloseButton=true>
                <img :src="`${apiUrl}${floorPlanUrl}`" alt="Planritning">
              </Modal>

              <Transition name="loader-fade" mode="out-in">
                <template v-if="!isFetching">
                  <div>
                  <div v-if="floorPlanUrl && this.selectedArea == 'apartment'" class="max-w-[628px] rounded-[4px] bg-primary-10 p-4 mb-4">
                    <h3 class="text-t6 mb-2">Ta hjälp av din planlösning</h3>
                    <p class="text-b2 mb-4">På din planlösning står det vad rummen heter.</p>
                    <Button variant="primary" size="large" @click="showBlueprint = !showBlueprint" class="sm:side-full md:size-fit">
                      {{ showBlueprint ? 'Dölj planlösning' : 'Visa planlösning' }}
                      <template #icon-after>
                        <IconFloorPlan color="white" />
                      </template>
                    </Button>
                  </div>

                  <ChooseLocation
                    v-model:id="locationId"
                    :dir="direction"
                    :areaCode="areaCode"
                    v-model:locationCode="locationCode"
                    v-model:hasBottomNode="hasBottomNode"
                    @change="onChange('locationCode', locationCode, hasBottomNode)"
                  />
                  </div>
                </template>
                <LoaderErrorReport v-else />
              </Transition>
            </div>

            <div v-if="step === 'partCode'" class="flex flex-col gap-4">
              <div
                class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                v-html="instructions.errorreport_create_edit_row_partcode_html"
              ></div>

              <Transition name="loader-fade" mode="out-in">
                <template v-if="!isFetching">
                  <ChoosePart
                    :dir="direction"
                    :areaCode="areaCode"
                    v-model:hasBottomNode="hasBottomNode"
                    v-model:parentId="parentId"
                    v-model:partCode="partCode"
                    v-model:categoryLevel="currentLevel"
                    v-model:partCodeName="partCodeName"
                    @part-selected="onChange('partCode', $event, hasBottomNode, parentId)"
                  />
                </template>
                <LoaderErrorReport v-else />
              </Transition>

            </div>


            <div v-if="step === 'subPartCode'" class="flex flex-col">
              <span class="w-fit text-label rounded-sm bg-primary-30 px-2 py-1 mb-2">VALFRITT</span>
              <div class="flex flex-col gap-4">
                <div
                  class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
                  v-html="instructions.errorreport_create_edit_row_subpartcode_html"
                ></div>
                <Transition name="loader-fade" mode="out-in">
                  <template v-if="!isFetching && subParts">
                    <ChooseSubPart
                      :dir="direction"
                      :areaCode="areaCode"
                      :hasBottomNode="hasBottomNode"
                      v-model:subPartCode="subPartCode"
                      @change="onChange('subPartCode', subPartCode, hasBottomNode)"
                    />
                  </template>
                  <LoaderErrorReport v-else />
                </Transition>
              </div>
            </div>

          <div v-if="step == 'description'" class="flex flex-col gap-4">
            <div
              class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
              v-html="instructions.errorreport_create_edit_row_description_html"
            ></div>
            <Description v-model:description="description" @input="onChange('description')" />
          </div>

          <div v-if="step == 'confirm-description'" class="flex flex-col gap-4">
            <div
              class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
              v-html="instructions.errorreport_create_edit_row_confirm_description_html"
            ></div>
            <ConfirmDescription :text="description" @input="onChange('confirm-description')" />
          </div>


          <div v-if="step == 'photos'" class="flex flex-col">
            <span class="w-fit text-label rounded-sm bg-primary-30 px-2 py-1 mb-2">VALFRITT</span>
            <div
              class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1 mb-4"
              v-html="instructions.errorreport_create_edit_row_photos_html"
            ></div>
            <Photos v-model="images" @input="onChange('photos')" />
          </div>

    <!--
          <div v-if="step == 'new-row-or-finish'" class="flex flex-col gap-4">
            <div
              class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
              v-html="instructions.errorreport_create_new_row_or_finish_html"
            ></div>
            <NewRowOrFinish />
          </div>
    -->

          <div v-if="step == 'access'" class="flex flex-col gap-4">
            <div
              class="[&_h2]:text-t5 [&_p]:text-b1 [&_h2]:mb-1"
              v-html="instructions.errorreport_create_access_html"
            ></div>
            <Access v-model:petsFieldIsValid="petsFieldIsValid"/>
          </div>

            <div v-if="step == 'confirm'" class="flex flex-col gap-4">
            <div
              v-for="(row, index) in rows"
              :key="row.id"
              class="flex flex-col gap-8"
            >
              <ErrorReportDisplay :rowId="row.id" :draft="draft" :goWhere="goWhere"/>
<!--              <ErrorReportDisplay :rowId="row.id" :draft="draft" :goWhere="(target) => goWhere(target, step)"/>-->
            </div>
            </div>
          </div>
          </main>
          <div ref="stickyRef" class="h-1 w-full"></div>
          <div
              class="
              mt-4 flex justify-between gap-4 border-t border-solid border-gray-light pt-4
              bg-white z-10 md:z-0
              sm:px-0
              sticky sm:relative bottom-0 left-0 right-0
              sm:pt-4
              md:rounded-none md:shadow-none
            "
              :class="isSticky ? 'w-[calc(100%+66px)] shadow-[0_0_9.2px_0_rgba(0,0,0,0.10)] rounded-t-[10px] pb-4 px-[33px] ml-[-33px]' : ''"
            >
              <Button v-if="hasPrev" @click="goBack(prev, step);" size="large" variant="secondary">
                <template #icon-before>
                  <IconArrowLeft />
                </template>
                Tillbaka
              </Button>
            <div class="ml-auto">
              <Button
                v-if="step != 'confirm'"
                :disabled="isDuplicate || (((isFetching || (!isSelected && step != 'access' && step != 'description')) && step != 'confirm-description' && step !== 'subPartCode' && step !== 'photos' && direction == 'next')) || (step == 'description' && (!this.description || (this.description && this.description.length<2))) || (step == 'access' && !this.petsFieldIsValid)"
                size="large"
                id="nextBtn"
                @click="goNext(next, step, hasBottomNode)"
              >
                Nästa
                <template #icon-after>
                  <IconArrowRight />
                </template>
              </Button>
              <Button
                v-else
                size="large"
                :loading="isLoading" loadingText="Skickar" :disabled="disable"
                @click="submitErrorReport">
                Skicka
                <template #icon-after>
                  <IconArrowRight />
                </template>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Stepper>
</template>

<script>
import Modal from '@/components/ui/modal';
import LoaderErrorReport from './loadererrorreport';
import Button from '@/components/ui/button';
import Stepper from '@/components/ui/stepper';
import InputWithCompression from '@/components/ui/inputwithcompression';
import ChooseArea from './choosearea';
import ChooseContract from './choosecontract';
import ChooseContractForLaundry from './choosecontractforlaundry';
import ChooseLaundryRoom from './chooselaundryroom';
import ChooseLocation from './chooselocation';
import ChoosePart from './choosepart';
import ChooseSubPart from './choosesubpart';
import Description from './description';
import Photos from './photos';
import IconReload from '@/components/icons/IconReload';
//import NewRowOrFinish from './new-row-or-finish';
import ErrorReportDisplay from '@/pages/create-error-report/error-report-display';

import Access from '@/pages/create-error-report/routes/access';

import ConfirmDescription from './confirmdescription';
import { dataLayerPush } from '@/helpers/datalayer';
import { mapGetters } from 'vuex';
import IconArrowRight from '@/components/icons/IconArrowRight';
import IconArrowLeft from '@/components/icons/IconArrowLeft';
import IconFloorPlan from '@/components/icons/IconFloorPlan';

import StepwizzardErrorReport from "@/components/ui/StepwizzardErrorReport.vue";

import { getMappedValue, isOutside } from '@/helpers/mapper';
import { API_BASEURL_V2 } from '@/config';
import { ref } from 'vue';

const isSticky = ref(false);
const stickyRef = ref(null);

const STATUS = {
  FAILED: 1,
  INVALID_ROWS: 2,
  SENT: 3,
};

const SPECIAL_LAUNDRY = ["laundryroom", "playground"];


const storeClears = {
  areaCode: [
    'clearCurrentCategories',
    'clearSubCategories',
    'clearSubParts',
    'clearApartmentContracts',
    'clearLaundryRooms'
  ],
  rentalObjectCode: [
    'clearCurrentCategories',
    'clearSubCategories',
    'clearSubParts',
    'clearLaundryRooms'
  ],
  locationCode: [
    'clearSubCategories',
    'clearSubParts',
    'clearLaundryRooms'
  ],
  laundryroom: [
    'clearSubCategories',
    'clearSubParts'
  ],
  partCode: (ctx) => {
    // specialregel
    if (getMappedValue(ctx.areaCode) === 'apartment' || ctx.areaCode === 'parkingspace') {
      return ['clearSubParts'];
    }
    return [];
  },
  subPartCode: []
};

const resets = {
  areaCode: [
    'rentalObjectCode',
    'locationCode',
    'laundryCode',
    'locationId',
    'parentId',
    'partCode',
    'partCodeName',
    'subPartCode',
    'blueprint'
  ],
  rentalObjectCode: [
    'laundryCode',
    'parentId',
    'partCode',
    'partCodeName',
    'subPartCode'
  ],
  locationCode: [
    'laundryCode',
    'partCode',
    'partCodeName',
    'parentId',
    'subPartCode'
  ],
  laundryroom: [
    'locationCode',
    'locationId',
    'partCode',
    'partCodeName',
    'parentId',
    'subPartCode'
  ],
  partCode: [
    'subPartCode'
  ],
  subPartCode: []
};


export default {
  components: {
    Button,
    InputWithCompression,
    ChooseArea,
    ChooseContract,
    ChooseLaundryRoom,
    ChooseLocation,
    ChoosePart,
    ChooseSubPart,
    Description,
    Photos,
    //NewRowOrFinish,
    Access,
    IconArrowLeft,
    IconArrowRight,
    Stepper,
    ConfirmDescription,
    ChooseContractForLaundry,
    IconFloorPlan,
    Modal,
    LoaderErrorReport,
    StepwizzardErrorReport,
    IconReload,
    ErrorReportDisplay
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    isDuplicate: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      // Vilket steg är man på
      history: [],
      petsFieldIsValid: true,
      currentLevel: 1,
      partCodeName: '',
      atStep: 'areaCode',
      stepNum: 1,
      isSelected: null,
      choicesMade: [],
      areaCode: null,
      rentalObjectCode: null,
      floorPlanUrl: null,
      locationCode: null,
      locationId: null,
      laundryCode: null,
      hasBottomNode: null,
      parentId: null,
      partCode: null,
      subPartCode: null,
      description: null,
      blueprint: null,
      newRowOrFinish: null,
      images: [],
      trackingPushed: [],
      currentStep: null,
      direction: "next",
      apiUrl: API_BASEURL_V2.split('/api').join(''),
      showBlueprint: false,
      isFetching: true,
      isLoading: false,
      disable: false,
      isSticky: false,
      ...STATUS,
    };
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
      getErrorReportsList: 'getErrorReportsList',
    }),
    row() {
      return this.$store.getters.getErrorReportRowById(this.id);
    },
    rows() {
      return this.$store.getters.getErrorReportRows;
    },
    draft() {
      return this.$store.getters.getErrorReportDraft;
    },

    subParts() {
      return this.$store.getters.getSubParts.length;
    },

    locationText() {
        if (!this.row || !this.row.locationCode) return;
        let room = this.$store.getters.getErrorReportAreas.find(c => c.roomTypeCode === this.row.locationCode);
        return room ? room.name : '';
    },

    partText() {
      if (!this.row || !this.row.partCode) return;
      let p = null;
      p = this.$store.getters.getSubCategories;
      let found = p.find(c => c.id === this.partCode || c.id == this.row.locationCode);
      return found ? found.name : '';

    },

    subPartText() {
      if (!this.row || !this.row.subPartCode) return;
      let p = this.$store.getters.getSubParts;
      let part = p.find(c => c.id === this.row.subPartCode);
      return part ? part.name : '';
    },

    baseCategories() {
      return this.$store.getters.getBaseCategories.length > 0;
    },

    /**
     * HTML-kode som administratörerna matat in som ska skrivas ut för varje steg
     */
    instructions() {
      return this.$store.getters.webapp_config.msg;
    },

    selectedArea() {
      if (!this.areaCode) return;

      return this.areaCode;
    },

    selectedContract() {
      if (!this.rentalObjectCode) return;
      return this.$store.getters.getErrorContractByRentalObjectCode(this.rentalObjectCode);
    },

    areaCodeText() {
      //for matomo
      if (this.areaCode == 'apartment') return 'I min lägenhet';
      else if (this.areaCode == 'parkingspace') return 'Vid min fordonsplats';
      else if (this.areaCode == 'laundryroom') return 'Tvättstugan';
      else if (this.areaCode == 'storagearea') return 'I mitt lägenhetsförråd';
      else if (this.areaCode == 'rentedstorage') return 'Förråd jag hyr';
      else if (this.areaCode == 'recyclingroom') return 'I mitt återvinningsrum';
      else if (this.areaCode == 'strollerroom') return 'I barnvagnsrum';
      else if (this.areaCode == 'outdoor') return 'Gården';
      else if (this.areaCode == 'staircase') return 'I trapphuset';
      else if (this.areaCode == 'basement') return 'I källaren eller vinden i mitt hus';
      else if (this.areaCode == 'bicyclegarage') return 'Cykelrum';
      else if (this.areaCode == 'playground') return 'Lekplats';
      return this.areaCode;
    },


    /**
     * Hyresgästens kontrakt av valda typer.
     */
    contractsOfSelectedType() {
      if (!this.selectedArea) return [];
      return this.$store.getters.getApartmentContracts;
    },

    hasRowWithErrorInApartment() {
      return this.$store.getters.getErrorReportRows.some(
        //TODO säkerställ
        (r) => r.areaCode == 'apartment' || r.areaCode == 'parking' || r.areaCode == 'premise',
      );
    },


    getParts() {
      return this.$store.getters.getSubCategories;
    },

    steps() {
      if (this.isFetching || !this.$store.getters.getBaseCategories.length) {
        return [];
      }
      const selectedArea = this.selectedArea;
      let contracts = this.$store.getters.getApartmentContracts;
      const moreThanOneContractOnSelectedType = contracts && contracts.length > 1;// this.contractsOfSelectedType.length > 1;
      if (!moreThanOneContractOnSelectedType && contracts && contracts.length == 1) {
        this.rentalObjectCode = contracts[0].value;
        this.floorPlanUrl = contracts[0].floorPlanUrl;
      }

      const moreThanOneLocationOnSelectedType = selectedArea && this.$store.getters.getErrorReportAreas.length > 1;
      let parts = [];
      if ((getMappedValue(this.areaCode) == 'apartment' || this.areaCode == 'parkingspace' || this.areaCode == 'rentedstorage' || this.areaCode == 'playground' || this.areaCode =='bicyclegarage')) {
        parts = this.$store.getters.getSubCategories;
      }
      else {
        parts = this.$store.getters.getSubParts;
      }

      let moreThanOnePartOnSelectedType = selectedArea && parts.length > 1;

      let moreThanOneSubPartOnSelectedType = selectedArea && this.$store.getters.getSubParts.length > 0;
      //if (!moreThanOneSubPartOnSelectedType) moreThanOneSubPartOnSelectedType = this.$store.getters.getSubCategories.length > 1;

      const descriptionContainKeywords =
        this.areaCode == 'apartment' && this.description &&
        this.$store.getters.errorReportDescriptionIncludeKeywords(this.description);

      /**
       * "Vart är felet?"
       */
      const steps = [
        {
          step: 'areaCode',
          route: 'vart-ar-felet',
          available: true,
          done: !!this.areaCode,
        },
      ];

      if ((this.areaCode == "parkingspace" || getMappedValue(this.areaCode) == 'apartment'  || this.areaCode == 'premises' || this.areaCode == 'rentedstorage') && moreThanOneContractOnSelectedType) {
        steps.push({
          step: 'rentalObjectCode',
          route: 'valj-kontrakt',
          available: !!this.areaCode,
          done: !!this.rentalObjectCode,
        });
      }

      if (this.areaCode == 'laundryroom' || this.areaCode == 'playground') {
        steps.push({
          step: 'laundryroom',
          route: 'valj-rum-annat',
          available: true,
          done: !!this.laundryCode,
        });
      }


      if (moreThanOneLocationOnSelectedType) {
        steps.push({
          step: 'locationCode',
          route: 'valj-rum',
          available: !!this.rentalObjectCode,
          done: false,
        });
      }

      if (moreThanOnePartOnSelectedType) {
        steps.push({
          step: 'partCode',
          route: 'valj-detalj',
          available: !!this.areaCode, // && this.$store.getters.getSubCategories.length > 0,
          done: false //!!this.partCode,
        });
      }


      if (moreThanOneSubPartOnSelectedType) {
        steps.push({
          step: 'subPartCode',
          route: 'valj-del',
          available: true, // && this.$store.getters.getSubParts.length > 0,
          done: false //!!this.subPartCode,
        });
      }

      steps.push({
        step: 'description',
        route: 'beskrivning',
        available: true,
        done: !!this.description,
      });

      if (descriptionContainKeywords) {
        steps.push({
          step: 'confirm-description',
          route: 'beskrivning',
          available: !!this.description,
          done: true,
        });
      }

      steps.push({
        step: 'photos',
        route: 'fotografier',
        available: true,
        done: false,
      });

      /*steps.push({
        step: 'new-row-or-finish',
        route: 'ny-rad-eller-klar',
        available: true,
        done: true,
      });*/
      if (this.areaCode == 'apartment' || this.areaCode == 'storagearea' || this.areaCode == 'parkingspace' || this.areaCode == 'premise' || this.areaCode == 'rentedstorage' ) {
        steps.push({
          step: 'access',
          route: 'tilltrade',
          available: this.description && this.description.length > 1,
          done: false,
        });
      }

      steps.push({
        step: 'confirm',
        route: 'bekrafta',
        available: this.description && this.description.length > 1,
        done: false,
      });


      return steps;
    },

  },
  watch: {
    areaCode: {
      immediate: true,
      handler(area, old) {},
    },
    partCode: {
      immediate: true,
      handler(val, old) {},
    },
    subPartCode: {
      immediate: true,
      handler(val, old) {},
    },
    locationCode: {
      immediate: true,
      handler(val, old) {},
    },
    locationId: {
      immediate: true,
      handler(val, old) { },
    },
    /**
     * Plocka ut värdena från raden i storen och sätt dem på internt.
     */
    id: {
      immediate: true,
      handler(id, oldId) {
        const row = this.$store.getters.getErrorReportRowById(id);

        if (!row) return;

        // Kopierar värdena så de finns internt
        Object.keys(row).forEach((key) => {
          if (key !== 'id') this[key] = row[key];
        });

        const s = this.$route.params.step;
        setTimeout(() => {
          this.$router.replace({
            name: 'ErrorReportEditRow',
            params: { rowId: id, step: s },
          });
        });
      },
    },

    // routen ska spegla aktuellt steg
    '$route.params.step': {
      immediate: true,
      handler(step) {
        this.atStep = step;
      },
    },
  },
  methods: {
    getStepText(step) {
      console.log("syep", step)
      if(step == 'areaCode') return 'Steg 1 - Var är felet?'
      else if(step == 'rentalObjectCode') return 'Steg 1.2 - Var är felet? - Hyresavtal'
      else if(step == 'laundryroom') return 'Steg 1.3 - Var är felet? - Tvättstuga'
      else if(step == 'playground') return 'Steg 1.3 - Var är felet? - Lekplats'
      else if(step == 'locationCode') return 'Steg 1.3 - Vilket utrymme är fel?'
      else if(step == 'partCode') return 'Steg 2 - Vad är felet?'
      else if(step == 'subPartCode') return 'Steg 2 - Vilken del är påverkad?'
      else if(step == 'description') return 'Steg 3 - Beskrivning'
      else if(step == 'photos') return 'Steg 4 - Foto'
      else if(step == 'access') return 'Steg 5 - Tillträde'
      return this.atStep;
    },
    onDirection(dir) {
      this.direction = dir;
    },
    goWhere(place) {
      this.atStep = null;

      setTimeout(() => {
        this.direction = 'prev';
        this.steps.forEach((s) => s.done = false); // nollställ
        this.atStep = place;
      }, 100);
    },

    async submitErrorReport() {
      if (this.disable) return;

      try {
        this.isLoading = true;
        this.disable = true;

        await this.$store.dispatch('submitErrorReportDraft');

        dataLayerPush({
          'event': 'serviceRequest',
          'step': 'Skicka in',
          'issueLocationAndCategory': this.areaCodeText + (this.partText ? " - " + this.partText : "")
        });

        this.status = STATUS.SENT;
      } catch (err) {
        console.log("err", err);
        this.status = STATUS.FAILED;
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'stepAndError': 'Granska och inskick - ' + err,
          'issueLocationAndCategory': this.areaCodeText + (this.partText ? " - " + this.partText : "")
        });
        this.disable = false;
        throw err;
      } finally {
        //this.$emit('update:modelValue', this.status);
        this.isLoading = false;
        this.$router.push({
          name: 'ErrorReportConfirm',
          params: { status: this.status }
        });
      }
    },


    resetErrorReportForm() {
      this.$store.dispatch('createErrorReportDraft');
      this.history = [];
      this.reset();
    },
    async goBack(prev, step) {
      if (!this.history.length) {
        return prev(); // redan på första sidan
      }


      dataLayerPush({
        'event': 'serviceRequestBackwards',
        'step': 'Backwards - ' + this.getStepText(step)
      });

      const last = this.history.pop();

      // Återställ värden
      this.currentLevel = last.currentLevel;
      this.areaCode = last.areaCode;
      this.rentalObjectCode = last.rentalObjectCode;
      this.locationId = last.locationId;
      this.locationCode = last.locationCode;
      this.partCode = last.partCode;
      this.subPartCode = last.subPartCode;
      this.parentId = last.parentId;

      // Ladda om rätt lista beroende på var vi hamnar
      await this.reloadLevel(last.step);

      prev(); // gå tillbaka i stegen

    },

    async reloadLevel(step) {
      const dispatch = this.$store.dispatch.bind(this.$store);

      switch (step) {
        case "contracts":
          return dispatch("fetchApartmentContracts", getMappedValue(this.areaCode));

        case "laundryroom":
          return dispatch("fetchLaundryRooms", { id: this.rentalObjectCode, type: this.areaCode });

        case "locationCode":
          return dispatch("fetchCategories", { id: this.locationId, type: this.areaCode });

        case "partCode":
          return dispatch("fetchSubParts", this.partCode);

        case "partsOutside":
          return dispatch("fetchPartsOutside", this.locationId);

        case "subPartCode":
          return dispatch("fetchSubParts", this.partCode);
      }
    },


    async goNext(next, step, hasSubCategories) {
      this.isFetching = true;
      window.scroll(0, 200);

      const { areaCode, rentalObjectCode, selectedContract, isSelected } = this;
      const dispatch = this.$store.dispatch.bind(this.$store);
      const mappedValue = getMappedValue(areaCode);


      dataLayerPush({
          'event': 'serviceRequest',
          'step': this.getStepText(step),
          'issueLocationAndCategory': this.areaCodeText + (this.partText ? " - " + this.partText : "")
      });



          const runAndNext = async (action, payload) => {
        this.history.push({
          step,
          areaCode: this.areaCode,
          rentalObjectCode: this.rentalObjectCode,
          locationId: this.locationId,
          locationCode: this.locationCode,
          partCode: this.partCode,
          subPartCode: this.subPartCode,
          parentId: this.parentId,
          currentLevel: this.currentLevel
        });

        try {
          const result = await dispatch(action, payload);
            if (result && result.length === 1 && step != "partCode") {
                const only = result[0];

                this.currentLevel = only.categoryLevel;

                if (step == "laundryroom" || step == "playground" || (step == 'rentalObjectCode' && (this.areaCode == "laundryroom" || this.areaCode == "playground")) ) {
                  this.parentId = only.id;
                }
                else if (step == "areaCode") {
                  if (this.areaCode === 'apartment') {
                    this.locationId = only.id;
                    this.locationCode = only.value;
                  }
                  else if (!SPECIAL_LAUNDRY.includes(this.areaCode)) {
                    this.locationId = only.id;
                    this.locationCode = only.id;
                  }
                }
                else if (!this.locationId) {
                  this.locationId = only.id;
                  this.locationCode = only.id;
                } else if(only.id) {
                  this.partCode = only.id;
                }

                this.updateRowInStore();

                this.isSelected = only.value || only.id;
                const nextAction = this.getNextAction(step, areaCode, only.hasBottomNode || only.hasSubcategories);
                if (!nextAction) {
                  this.isFetching = false;
                  this.isSelected = null;
                  return next();
                }
                // hämta alternativen för nästa steg
                let val;

                if (nextAction === 'fetchCategories') {
                  val = { id: this.isSelected, type: this.areaCode };
                } else if (nextAction === 'fetchLaundryRooms') {
                  val = { id: this.rentalObjectCode, type: this.areaCode };
                } else {
                  val = this.isSelected;
                }


                const actionResult = await dispatch(nextAction, val);

                let nextNextResult = [];
                if (actionResult.length == 1 && step!='partCode') {
                  nextNextResult = await dispatch(this.getNextAction(step, areaCode, actionResult[0].hasBottomNode || actionResult[0].hasSubcategories), actionResult[0].id);
                  if (nextNextResult && nextNextResult.length === 1) {
                    const onlynext = nextNextResult[0];
                  }
                }

                /* set values....*/
                if(actionResult.length == 1){
                  if(actionResult[0].categoryLevel == "four" && nextAction !== "fetchLaundryRooms") {
                    this.locationId = actionResult[0].id;
                    this.locationCode = actionResult[0].roomTypeCode;
                  }
                  else if(actionResult[0].id) {
                    this.partCode = actionResult[0].id;
                  }
                  this.currentLevel = actionResult[0].categoryLevel;

                }


                let parts = [];
                if ((getMappedValue(this.areaCode) == 'apartment' || this.areaCode == 'parkingspace' || this.areaCode == 'rentedstorage')  && this.areaCode !='playground') {
                  parts = this.$store.getters.getSubCategories;
                }
                else {
                  parts = this.$store.getters.getSubParts;
                }

                if (parts.length == 1 && parts[0].id) {
                  this.partCode = parts[0].id;
                  this.currentLevel = parts[0].categoryLevel;
                  if (parts[0].parentId) this.parentId = parts[0].parentId;
                }
                if(this.$store.getters.getSubParts.length == 1){
                  //this.subPartCode = this.$store.getters.getSubParts[0].id
                }
                if (this.areaCode == 'apartment') {
                  if(this.$store.getters.getSubCategories.length == 1) this.subPartCode = this.$store.getters.getSubCategories[0].id
                }

                this.isFetching = false;
                this.isSelected = null;
                return next();

          }

        } finally {
          this.isSelected = null;
          this.isFetching = false;
          this.$nextTick(next);
        }
      };

      try {
        // AREA CODE – redan har rentalObjectCode
        if (step === "areaCode" && rentalObjectCode) {
          return runAndNext("fetchCategories", { id: rentalObjectCode, type: areaCode });
        }

        // AREA CODE – hämta kontrakt först
        else if (step === "areaCode" && !selectedContract) {
          await dispatch("fetchApartmentContracts", mappedValue);
          const contracts = this.$store.getters.getApartmentContracts || [];

          if (contracts.length === 1) {
            this.rentalObjectCode = contracts[0].value;
            if (this.rentalObjectCode) {
              return runAndNext("fetchCategories", { id: this.rentalObjectCode, type: areaCode });
            }
          }

          this.isFetching = false;
          this.isSelected = null;
          return this.$nextTick(next);
        }

        // LAUNDRYROOM / PLAYGROUNDS
        else if (step === "laundryroom" && SPECIAL_LAUNDRY.includes(areaCode)) {
          return runAndNext("fetchCategories", { id: isSelected, type: areaCode });
        }

        // AREA CODE – parkering, förråd, utomhus
        else if (step === "areaCode" && ["parkingspace", "outdoor", "storagearea"].includes(areaCode)) {
          return runAndNext("fetchCategories", { id: isSelected, type: areaCode });
        }

        // LOCATIONCODE / RENTALOBJECTCODE (endast en kontraktstyp)
        else if ((step === "locationCode") ||
          //här
          (step === "rentalObjectCode" && !["laundryroom", "parkingspace", 'playground', 'recyclingroom', 'strollerroom', 'outdoor', 'staircase', 'basement', 'bicyclegarage'].includes(areaCode))) {


          if(isOutside(areaCode) && areaCode != "storagearea"  && areaCode != "rentedstorage") {
            return runAndNext("fetchPartsOutside", isSelected);
          }
          else if(this.areaCode == 'apartment' && step!='rentalObjectCode'){
            return runAndNext("fetchSubCategories", this.locationCode)
          }
          return runAndNext("fetchCategories", { id: this.rentalObjectCode, type: areaCode });
        }

        // Flera kontraktstyper → hämta subkategorier
        else if ((step === "rentalObjectCode" && this.contractsOfSelectedType.length > 1 && !SPECIAL_LAUNDRY.includes(areaCode)) ||
          (step === "locationCode" && this.contractsOfSelectedType.length > 1)) {
          if (this.areaCode == 'apartment') return runAndNext("fetchSubCategories", this.locationCode);
          //här
          else if(this.areaCode == 'parkingspace' || this.areaCode == 'recyclingroom' || this.areaCode == 'strollerroom' || this.areaCode == 'outdoor' || this.areaCode == 'staircase' || this.areaCode == 'basement' || this.areaCode == 'bicyclegarage' || this.areaCode == 'playground') return runAndNext("fetchCategories", {id: 'parkingSpace', type: areaCode});
          else {
            return runAndNext("fetchSubParts", isSelected);
          }
        }

        // LAUNDRYROOM / PLAYGROUNDS (rentalObjectCode)
        else if (((step === "areaCode" && rentalObjectCode) || (step === "rentalObjectCode" && rentalObjectCode)) &&
          SPECIAL_LAUNDRY.includes(areaCode)) {
          return runAndNext("fetchLaundryRooms", { id: rentalObjectCode, type: areaCode });
        }

        // PART CODE
        else if (step === "partCode" && hasSubCategories) {
          return runAndNext("fetchSubParts", isSelected);
        }

        else {
          this.isSelected = null;
          this.isFetching = false;
          return this.$nextTick(next);
        }

      } catch (err) {
        console.error("goNext error:", err);
        this.isFetching = false;
        this.isSelected = null;
        this.$nextTick(next);
      }
    },


    getNextAction(step, areaCode, hasSubCategories) {

      // --- AREA CODE HANDLING ---
      if (!hasSubCategories) return;

      // apartment → first fetch contracts, then categories/subcategories later
      if (step === "areaCode" && areaCode === "apartment") {
        return "fetchApartmentContracts";
      }

      // laundryroom / playground → next step is laundryrooms
      if (step === "areaCode" && SPECIAL_LAUNDRY.includes(areaCode)) {
        return "fetchLaundryRooms";
      }

      // parkering / förråd / utomhus → categories direkt
      if (step === "areaCode" && this.currentLevel != "three") {//["outdoor", "storagearea"].includes(areaCode)) {
        return "fetchCategories";
      }

      if (step === "areaCode" && this.currentLevel == "three") {
        return "fetchPartsOutside";
      }

      // default areaCode → categories
      if (step === "areaCode") {
        return "fetchCategories";
      }


      // --- RENTAL OBJECT HANDLING ---
      // multiple contracts → subcategories (apartment)
      if (step === "rentalObjectCode" && areaCode === "apartment" && this.contractsOfSelectedType > 1) {

      }

      // multiple contracts → subparts (others)
      else if (step === "rentalObjectCode" && this.contractsOfSelectedType > 1) {
        return "fetchSubParts";
      }

      else if (step === "partCode") {
        return "fetchSubParts";
      }

      //här
     // (this.areaCode == "parkingspace" || getMappedValue(this.areaCode) == 'apartment'  || this.areaCode == 'premises' || this.areaCode == 'rentedstorage') && moreThanOneContractOnSelectedType
      else if (step === "rentalObjectCode" && this.areaCode != 'parkingspace' && this.areaCode != 'rentedstorage' && this.areaCode != 'outdoor'  && this.areaCode != 'staircase'  && this.areaCode != 'basement' && this.areaCode != 'playground' && this.areaCode != 'laundryroom') {
        if (this.currentLevel == "three") return "fetchPartsOutside"
        else return "fetchSubParts"
      }
      else if (step === "rentalObjectCode") {
        return "fetchPartsOutside"
      }

      // laundryroom / playground already handled earlier
      if (step === "laundryroom" && SPECIAL_LAUNDRY.includes(areaCode)) {
        return "fetchPartsOutside";
      }

      else {
        console.log("none")
      }

    },

    updateRowInStore() {
      return this.$store.dispatch('updateErrorReportRow', {
        id: this.id,
        areaCode: this.areaCode,
        rentalObjectCode: this.rentalObjectCode,
        locationCode: this.locationCode,
        locationId: this.locationId,
        parentId: this.parentId,
        laundryCode: this.laundryCode,
        partCode: this.partCode,
        partCodeName: this.partCodeName,
        subPartCode: this.subPartCode,
        description: this.description,
        blueprint: this.blueprint,
        images: this.images,
      });
    },

    restoreStore() {
      this.$store.dispatch('createErrorReportDraft');
    },
    /**
     * Vad ska hända när ett fält är korrekt ifyllt?
     */
    async onChange(field, val, hasBottomNode) {
      await this.$nextTick();
      this.isSelected  = val;
      if (hasBottomNode != undefined) this.hasBottomNode = hasBottomNode;

      if(this.direction == 'prev') {
        //reset store values för later steps
        const clears = storeClears[field];

        if (typeof clears === 'function') {
          // specialregel för partCode
          clears(this).forEach(method => {
            this.$store.cache.dispatch(method);
          });
        } else if (Array.isArray(clears)) {
          clears.forEach(method => {
            this.$store.cache.dispatch(method);
          });
        }
      }

      //reset values later steps in flow
      if (resets[field]) {
        resets[field].forEach(key => {
          this[key] = null;
        });
      }

      // om det bara finns en part att välja på ska den väljas uatomatisk
      if (this.getParts.length == 1 && this.getParts[0].id) {
        this.partCode = this.getParts[0].id;
        if (this.getParts[0].parentId) this.parentId = this.getParts[0].parentId;
      }

      this.updateRowInStore(); // tala om för store att värdena ändrats
      this.direction = "next";

      //comment out to not move forward
       //cb && this.$nextTick(cb);
    },

    /**
     * Uppdatera route när man byter steg
     */
    stepChanged(newStep) {
      this.$router.push({
        name: 'ErrorReportEditRow',
        params: { rowId: this.id, step: newStep.route },
      });
    },

    /**
     * Reserat state
     */
    reset() {
      /*dataLayerPush({
        event: 'stepErrorReport',
        errorstep: 'återställ ' + this.atStep,
        errorReportTyp: this.areaCodeText,
      });*/

      this.trackingPushed = null;


      this.floorPlanUrl = null;
      this.hasBottomNode = null;
      this.currentStep = null;

      this.locationId = null;
      this.areaCode = null;
      this.rentalObjectCode = null;
      this.locationCode = null;
      this.laundryCode = null;
      this.partCode = null;
      this.partCodeName = null;
      this.parentId = null;
      this.subPartCode = null;
      this.description = null;
      this.blueprint = null;
      this.images = null;
      this.isSelected = null;

      // Gå till första steget
      this.atStep = null;
      this.$nextTick(() => { this.atStep = 'vart-ar-felet'; });
      this.stepNum = 1;

      this.trackingPushed = [];

      this.restoreStore();
      // Om raden finns i store ska den uppdateras där med.
      //if (this.$store.getters.getErrorReportRowById(this.id)) this.updateRowInStore();
    },
  },
  created() {
    this.$store.cache.dispatch('clearApartmentContracts');
    this.$store.cache.dispatch('clearLaundryRooms');
    this.$store.cache.dispatch('clearSubCategories');
    this.$store.cache.dispatch('clearSubParts');


    return this.$store.cache.dispatch('fetchContracts').finally(() => {
      this.isFetching = false;
    });

    /**
     * Om raden tas bort i store ska den oxå tas bort internt
     */
   /* return this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'deleteErrorReportRow' && mutation.payload == this.id) {
        this.reset();
      }
    });*/
  },
  mounted() {

    const observer = new IntersectionObserver(
      ([entry]) => {
        this.isSticky = !entry.isIntersecting && window.innerWidth < 600;
      },
      { threshold: 1 }
    );

    observer.observe(this.$refs.stickyRef);
  }
};
</script>


<style scoped>
/* --- FADE BETWEEN COMPONENTS --- */
.loader-fade-enter-active,
.loader-fade-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.loader-fade-enter-from,
.loader-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.sticky-wrapper {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  background: white;
  z-index: 50;
}

.actions-container {
  max-width: 840px;
}

.is-sticky {
  box-shadow: 0 0 12px rgba(0,0,0,0.15);
}

</style>
